import styled from 'styled-components';

// Note(Anson Kan): `2em` is an arbitrary size to offset the width of `li`'s ::marker
const LIST_PADDING_LEFT = '2em';

export const PaddedOl = styled.ol`
  padding-left: ${LIST_PADDING_LEFT};
`;

export const PaddedUl = styled.ul`
  padding-left: ${LIST_PADDING_LEFT};
`;
